import * as React from "react";
import { useEffect, useState } from "react";
import { DashboardAction } from "../../Action/DashboardAction";
import { NotificationAction } from "../../Action/NotificationAction";
import { DashboardTab } from "../../Resource/Content";
import { DashboardFilterStore, NotificationFilterStore } from "../../Store/Variable";

export interface DashboardFiltersProps {
    onEdit?: (FilterId: number) => void;
    data?: any;
    pressedId?: number;
    tab: DashboardTab;
}
export const DashboardFilters = (props: DashboardFiltersProps): JSX.Element => {
    const [ResultCount, setResultCount] = useState(null);

    useEffect(() => {
        if (props.tab == DashboardTab.Workflow) {
            const query = DashboardFilterStore.convertDashboardFilterToQuery(props.data, 1, null, null, null);

            DashboardAction.getWorkflowTable(query, (d) => {
                setResultCount(d?.TotalNumberOfResults);
            });
        } else {
            const query = NotificationFilterStore.convertDashboardFilterToQuery(props.data, 1);

            NotificationAction.getNotificationTable(query, (d) => {
                setResultCount(d?.Pager?.TotalRecords);
            });
        }
    }, [props.tab, props.data]);

    return (
        <div
            key={props.data.FilterId}
            className="col-12 col-xs-6 col-md-auto col-equalise"
            onClick={(e) => {
                e.stopPropagation();
                props.tab == DashboardTab.Workflow
                    ? DashboardAction.setPressedId(props.data.FilterId)
                    : NotificationAction.setPressedId(props.data?.FilterId);
            }}
        >
            <div className="summary-tile ad d1">
                <button
                    id={props.data.FilterId?.toString()}
                    type="button"
                    className="summary-tile-filter-button"
                    aria-pressed={props.pressedId == props.data.FilterId}
                >
                    {ResultCount != null ? (
                        <span className="ring">{ResultCount}</span>
                    ) : (
                        <div className="skeleton summary-tile" />
                    )}
                    <span
                        className="text"
                        style={{
                            overflowWrap: "break-word",
                            width: "120px",
                            display: "inline-block",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {props.data?.FilterName}
                    </span>
                </button>
                <div className="edit-wrap">
                    <div className="popover-edit">
                        <button
                            className="trigger"
                            title="Edit"
                            onClick={(e) => {
                                e.stopPropagation();
                                props.onEdit(props.data.FilterId);
                            }}
                        >
                            <span className="sr-only">Edit {props.data.FilterName}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
